import './App.css';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { Analytics } from '@vercel/analytics/react';

const THEME_COLORS = {
  'clear-day': '#DCEEFB',
  'cloudy':    '#EFF2F5',
  'rain':      '#D6E1EB',
  'night':     '#0D1117',
};

function App() {
  const [weather, setWeather] = useState(null);
  const bgType = weather?.bg_type || 'cloudy';

  useEffect(() => {
    const color = THEME_COLORS[bgType] || '#EFF2F5';
    document.documentElement.className = bgType;
    document.body.className = bgType;
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.content = color;
    return () => {
      document.documentElement.className = '';
      document.body.className = '';
    };
  }, [bgType]);

  useEffect(() => {
    const lock = (e) => e.preventDefault();
    document.addEventListener('touchmove', lock, { passive: false });
    return () => document.removeEventListener('touchmove', lock);
  }, []);

  useEffect(() => {
    let didCancel = false;

    const fetchByQuery = async (q) => {
      try {
        const res = await axios.get(`/api?location=${encodeURIComponent(q)}`);
        if (!didCancel) {
          setWeather(res.data);
          localStorage.setItem('location', q);
        }
      } catch (err) {
        if (!didCancel) console.error('error:', err);
      }
    };

    const fallback = () => {
      const saved = localStorage.getItem('location');
      fetchByQuery(saved || 'reykjavík');
    };

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => fetchByQuery(`${pos.coords.latitude},${pos.coords.longitude}`),
        fallback,
        { enableHighAccuracy: true, timeout: 8000, maximumAge: 60000 }
      );
    } else {
      fallback();
    }

    return () => { didCancel = true; };
  }, []);

  if (!weather) {
    return (
      <div className="app">
        <div className="card">
          <p className="loading">Hleður…</p>
        </div>
        <Analytics />
      </div>
    );
  }

  const { name } = weather.location;
  const { temp_c, condition } = weather.current;


  return (
    <div className={`app ${bgType}`}>
      <div className="card">
        <div className="card-header">
          <span className="brand">bjórveður.is</span>
          <div className="weather-chip">
            <img src={condition.icon} alt={condition.text} className="weather-icon" />
            <span className="temp">{Math.round(temp_c)}°</span>
          </div>
        </div>
        <p className="location">{name} · {condition.text}</p>
        <p className="date">{new Intl.DateTimeFormat('is', { weekday: 'long', day: 'numeric', month: 'long' }).format(new Date()).replace(/^\w/, c => c.toUpperCase())}</p>

        <div className="beer-image-wrap">
          <img src={weather.beer_image_url} alt={weather.beer_name} />
        </div>

        <div className="beer-details">
          <p className="today-label">BJÓR STUNDARINNAR</p>
          <h1 className="beer-name">{weather.beer_name}</h1>
          {weather.beer_tags && <p className="beer-tags">{weather.beer_tags}</p>}
          {weather.beer_description && <p className="beer-desc">{weather.beer_description}</p>}
        </div>
      </div>
      <Analytics />
    </div>
  );
}

export default App;
